import type { Middleware } from '@reduxjs/toolkit'
import { isRejectedWithValue } from '@reduxjs/toolkit'

export const apiErrorMiddleware: Middleware = () => next => action => {
  if (!isRejectedWithValue(action)) return next(action)

  if (action.payload?.status === 403) {
    console.log('error')
  }

  return next(action)
}
